import GeneralUtilsHelper from "@/utils/generalUtils";
import { ActionTree } from "vuex";
import * as types from "@/store/constants/types";
import Http from "@/api/http/fetch/index";
import {
  getInsUserInfoById,
  loginByFb,
  searchInsUser
} from "@/api/http/ins/insUser";
import { getUserProfile } from "@/api/http/ins/web/webUserInfo";
import { login, getUserInfoById, disconnectUser } from "@/api/http/gx/gxUser";
import EventBus from "@/utils/eventBus";
import { sendEvent } from "@/utils/analytics";

const actions: ActionTree<any, any> = {
  async [types.UPDATE_USER_INS_INFO](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      let insUserInfo: any;
      if (getters[types.GETTER_CURRENT_INS_USER_INFO].userType === "search") {
        const login_id = getters[types.GETTER_INS_LOGIN_USER_ID];
        insUserInfo = await searchInsUser(payload.username, login_id);
      } else {
        insUserInfo = await getInsUserInfoById(payload.userId);
      }
      commit(types.RECEIVE_INS_USER_INFO_DATA, {
        userId: payload.userId,
        insUserInfo: insUserInfo.user
      });
      commit(types.UPDATE_USER, {
        userId: payload.userId,
        userName: insUserInfo.user.username,
        userPic: insUserInfo.user.profile_pic_url,
        hasNoProfilePic:
          !insUserInfo.user.profile_pic_url ||
          insUserInfo.user.has_anonymous_profile_picture,
        hasNoProfileMedia: insUserInfo.user.media_count === 0
      });
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [types.LOGIN_BY_FB]({ state, commit, dispatch }, payload: any) {
    try {
      const token: any = await Http.FbLogin();
      EventBus.$emit("toast-show", {
        type: "loading",
        content: "Logining…",
        duration: "infinite"
      });
      console.log("LOGIN_BY_FB: token", token);
      if (token.hasOwnProperty("status") && token.status === "fail") {
        console.log("token.error", token.error);
        EventBus.$emit("toast-hide");
        return Promise.reject(token.error);
      }
      const result: any = await loginByFb(token);
      console.log("LOGIN_BY_FB: insUserInfo", result);
      await dispatch(types.ADD_USER, {
        userId: result.logged_in_user.pk,
        userType: "login"
      });
      EventBus.$emit("toast-hide");
    } catch (error) {
      EventBus.$emit("toast-hide");
      console.log("LOGIN_FAILED_REASON", error);
      return Promise.reject(error);
    }
  }
};

export default actions;
